import Stepper from '@mui/material/Stepper';
import { Paper, Step, StepLabel, Typography } from '@mui/material';

const points = [
  'Greeting',
  'Talking with AI',
  'Plan discussion',
  'Plan step 1',
  'Plan step 2',
  'Plan step 3',
  'Plan step 4',
  'Quit plan confidence',
  'Plan step 5',
  'Plan step 6',
  'Final steps',
  'Got plan',
];

interface ICustomTimelineProps {
  status: string | undefined;
}

const CustomTimeline: React.FC<ICustomTimelineProps> = ({ status }) => {
  const activeStep = points.findIndex((point) => point === status);
  const createTimelineItems = () => {
    return points.map((point) => {
      return (
        <Step key={point}>
          <StepLabel>{point}</StepLabel>
        </Step>
      );
    });
  };

  return (
    <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Current journey state
      </Typography>
      <Stepper activeStep={activeStep} alternativeLabel>
        {createTimelineItems()}
      </Stepper>
    </Paper>
  );
};

export default CustomTimeline;
